module.exports = __webpack_public_path__ + "img/tops-blouse.83a10616.png";